/* import __COLOCATED_TEMPLATE__ from './pending-opt-out-card.hbs'; */
/* RESPONSIBLE TEAM: team-self-serve */

import type AppService from 'embercom/services/app-service';
import { inject as service } from '@ember/service';
import Component from '@glimmer/component';
import type IntlService from 'embercom/services/intl';

interface PendingOptOutCardArgs {
  dataSharingOptOut: {
    requestedBy: string;
    requestedAt: Date;
    requesterName?: string;
  };
}

export default class PendingOptOutCard extends Component<PendingOptOutCardArgs> {
  @service declare appService: AppService;
  @service declare intl: IntlService;

  get requesterName() {
    let requestedBy = this.args.dataSharingOptOut?.requestedBy;
    let unknownText = this.intl.t(
      'new-settings.workspace.security.models-data-sharing.pending-opt-out-card.unknown',
    );

    if (!requestedBy) {
      return unknownText;
    }

    let admin = this.appService.app.admins.findBy('id', requestedBy.toString());
    if (admin) {
      return admin.name;
    }

    return this.args.dataSharingOptOut?.requesterName || unknownText;
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'NewSettings::Workspace::SecurityModelsDataSharing::PendingOptOutCard': typeof PendingOptOutCard;
    'new-settings/workspace/security-models-data-sharing/pending-opt-out-card': typeof PendingOptOutCard;
  }
}
